import { render, staticRenderFns } from "./advertisingSituation.vue?vue&type=template&id=79035c01&scoped=true"
import script from "./advertisingSituation.vue?vue&type=script&lang=js"
export * from "./advertisingSituation.vue?vue&type=script&lang=js"
import style0 from "./advertisingSituation.vue?vue&type=style&index=0&id=79035c01&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79035c01",
  null
  
)

export default component.exports